import { Router } from '@angular/router';
import { UserDetails } from 'src/app/shared/models/userDetail.model';
import { CoreService } from 'src/app/core/services/core.service';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { DASHBOARD_URL } from 'src/app/shared/constants/constant';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public show = false;
  public userDetails: UserDetails;
  constructor(private authService: MsalService,
    private router: Router,
     private coreService: CoreService) { }

  ngOnInit(): void {
    this.userDetails = this.coreService.getLoggedInUserDetails();
  }

  public showProfile(): void {

  }

  logout() {
    this.authService.logout();
  }

  public onFocusout(): void {
    this.show = false;
  }

  /**
   * viewUserDetails
   */
  public viewUserDetails(): void {
    this.show = false;
    this.router.navigateByUrl(`${DASHBOARD_URL}/user/${this.coreService.getLoggedInID()}`);
  }

}
